/**
 * InstrumentProvider — základní třída pro PUSH/event čtení z měřicího přístroje.
 *
 * Refaktor ADR-008: dříve synchronní PULL `readValue(nominal)`; nově HW sám streamuje
 * vzorky a posílá je subscriberům. Reading: { value, unit, status, stable, raw, ts }.
 *
 * Kontrakt potomků:
 *   async connect()    — naváže spojení (HID: getDevices/requestDevice + open)
 *   async disconnect() — uzavře spojení
 *   start() / stop()   — spustí/zastaví příjem vzorků
 * Společné z base:
 *   subscribe(cb)      — cb(reading); vrací unsubscribe
 *   subscribeState(cb) — cb(connectionState); ihned zavolá s aktuálním stavem; vrací unsubscribe
 */

export const ConnectionState = {
  DISCONNECTED: 'disconnected',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  ERROR: 'error',
};

export class InstrumentProvider {
  constructor() {
    this._readingSubs = new Set();
    this._stateSubs = new Set();
    this._state = ConnectionState.DISCONNECTED;
  }

  get name() { return 'Generic'; }

  get isMock() { return false; }

  get connectionState() { return this._state; }

  get isConnected() { return this._state === ConnectionState.CONNECTED; }

  subscribe(cb) {
    this._readingSubs.add(cb);
    return () => this._readingSubs.delete(cb);
  }

  subscribeState(cb) {
    this._stateSubs.add(cb);
    cb(this._state);
    return () => this._stateSubs.delete(cb);
  }

  _emitReading(reading) {
    this._readingSubs.forEach((cb) => {
      try { cb(reading); } catch (_e) { /* chyba subscribera nesmí shodit provider */ }
    });
  }

  _setState(state) {
    this._state = state;
    this._stateSubs.forEach((cb) => {
      try { cb(state); } catch (_e) { /* viz výše */ }
    });
  }

  async connect() { throw new Error('connect() není implementováno.'); }

  async disconnect() { /* potomek přepíše */ }

  start() { /* potomek přepíše */ }

  stop() { /* potomek přepíše */ }
}
